import CustomLoader from "../../ui/CustomLoader/CustomLoader";
import { ResultErrorFallback } from "../../shared/result/ResultErrorFallback";
import { SuccessView } from "./result/SuccessView";
import { FailedView } from "./result/FailedView";
import { ProcessingView } from "./result/ProcessingView";

export function Step4Result({
  transactionId,
  status,
  createdDate,
  amount,
  transactionFee,
  totalDeducted,
  newBalance,
  remarks,
  isLoadingDisbursement,
  isDisbursementError,
  refetchDisbursement,
  onNewWithdrawal,
  onViewTransactions,
}) {
  if (!transactionId) {
    return (
      <FailedView
        remarks={remarks ?? "Unable to process withdrawal."}
        onNewWithdrawal={onNewWithdrawal}
      />
    );
  }

  if (!status && isLoadingDisbursement) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CustomLoader
          type="oval"
          color="primary"
          size="md"
          text="Fetching transaction details..."
          textPosition="center"
          textColor="text-primary-500"
        />
      </div>
    );
  }

  if (!status && isDisbursementError) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <ResultErrorFallback
          title="Unable to Load Details"
          message="We couldn't load your transaction details."
          primaryLabel="View in Transactions"
          onPrimaryClick={onViewTransactions}
          onRetry={refetchDisbursement}
        />
      </div>
    );
  }

  if (status === "SUCCESS") {
    return (
      <SuccessView
        amount={amount}
        transactionId={transactionId}
        createdDate={createdDate}
        transactionFee={transactionFee}
        totalDeducted={totalDeducted}
        newBalance={newBalance}
        onNewWithdrawal={onNewWithdrawal}
        onViewTransactions={onViewTransactions}
      />
    );
  }

  if (status === "FAILED" || status === "REVERSED") {
    return (
      <FailedView
        amount={amount}
        transactionId={transactionId}
        createdDate={createdDate}
        transactionFee={transactionFee}
        newBalance={newBalance}
        remarks={remarks}
        status={status}
        onNewWithdrawal={onNewWithdrawal}
      />
    );
  }

  return (
    <ProcessingView
      amount={amount}
      transactionId={transactionId}
      createdDate={createdDate}
      transactionFee={transactionFee}
      totalDeducted={totalDeducted}
      newBalance={newBalance}
      onViewTransactions={onViewTransactions}
    />
  );
}
